/** CommandDashboardRoute — skin-aware switcher for /command-dashboard. */
import { useUISkin } from "@/data/UISkinContext";
import CommandDashboard from "./CommandDashboard";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";
import {
  useCommandDashboardLens,
  CommandDashboardLensSwitch,
  CommandDashboardLensBody,
} from "@/components/dashboard/CommandDashboardLens";

export default function CommandDashboardRoute() {
  const { skin } = useUISkin();
  const { lens, setLens, eligible } = useCommandDashboardLens();

  if (skin === "cockpit") {
    if (eligible) {
      return (
        <CockpitFrame
          title="Command Dashboard"
          rightSlot={<CommandDashboardLensSwitch value={lens} onChange={setLens} />}
        >
          <CommandDashboardLensBody lens={lens} />
        </CockpitFrame>
      );
    }
    return (
      <CockpitFrame title="Command Dashboard">
        <CommandDashboard />
      </CockpitFrame>
    );
  }
  return <CommandDashboard />;
}
